import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { CaseEdits } from './action-types';
import { api } from '../core/net';
import { cmxDateTime, HttpMethods, codeBenchActions } from '@codametrix/ui-common';
import { patientDetailDictionaries } from '../reducers/state/case-edits';
const { fetchActivity } = codeBenchActions;
const updateValue = createAction(CaseEdits.UPDATE_VALUE);
const loadPatientDetailOptions = createAsyncThunk(CaseEdits.LOAD_PATIENT_DETAIL_OPTIONS, async (payload, _thunkAPI)=>{
    const { activeTenantId, facility, dictionary } = payload;
    const dictionaryInfo = patientDetailDictionaries[dictionary];
    let fieldOptions = {
        standardFields: [],
        additionalFields: []
    };
    try {
        if (dictionaryInfo) {
            let { dictionaryName, columnName } = dictionaryInfo;
            const searchParams = new URLSearchParams({
                tenantId: activeTenantId,
                derivedIndicator: 'true',
                effectiveDate: cmxDateTime.format(new Date(), cmxDateTime.FORMATS.DATE),
                dictionaryName: dictionaryName,
                columnName: columnName
            });
            const res = await api({
                endpoint: `/dictionary/row/unrestricted/v2?${searchParams.toString()}`,
                init: {
                    method: HttpMethods.GET
                }
            });
            const dictionaryFieldHandlers = {
                Department: (row)=>{
                    fieldOptions.standardFields.push({
                        label: row['Unit/Department'],
                        value: row['Unit/Department ID']
                    });
                },
                'Patient Class': (row)=>{
                    fieldOptions.standardFields.push({
                        label: row[columnName],
                        value: row[columnName]
                    });
                    fieldOptions.additionalFields.push({
                        label: row['Patient Type'],
                        value: row['Patient Class Original']
                    });
                },
                'Note Specialty': (row)=>{
                    if (row?.['Facility'] === facility) {
                        fieldOptions.standardFields.push({
                            label: row[columnName],
                            value: row[columnName]
                        });
                    }
                },
                default: (row)=>{
                    fieldOptions.standardFields.push({
                        label: row[columnName],
                        value: row[columnName]
                    });
                }
            };
            res.rowValues.forEach((row)=>{
                (dictionaryFieldHandlers[dictionaryName] || dictionaryFieldHandlers['default'])(row);
            });
        }
    } catch (e) {
        console.log(e);
    }
    return fieldOptions;
});
const loadAllPatientDetailOptions = createAsyncThunk(CaseEdits.LOAD_ALL_PATIENT_DETAIL_OPTIONS, async (payload, { dispatch })=>{
    const { activeTenantId, facility } = payload;
    Object.keys(patientDetailDictionaries).forEach((dictionary)=>{
        dispatch(loadPatientDetailOptions({
            activeTenantId,
            facility,
            dictionary
        }));
    });
});
const updateCase = createAsyncThunk(CaseEdits.UPDATE_CASE, async (params, { dispatch })=>{
    const { caseRunUid, serviceLine, caseUpdates, initialVal, mappedValues } = params;
    if (Object.keys(caseUpdates).includes('scheduling_department')) {
        const code = mappedValues.find((map)=>{
            return map.label === caseUpdates['scheduling_department'];
        })?.value;
        caseUpdates['scheduling_department_code'] = code;
    }
    try {
        const updatedProcessInstance = await api({
            endpoint: `/coding-api/processinstance/${serviceLine}/${caseRunUid}/v1`,
            init: {
                method: HttpMethods.PUT,
                body: JSON.stringify(caseUpdates)
            }
        });
        dispatch(fetchActivity(updatedProcessInstance));
    } catch (e) {
        dispatch(updateValue(initialVal));
    }
});
export const caseEditsActions = {
    updateValue,
    loadPatientDetailOptions,
    loadAllPatientDetailOptions,
    updateCase
};
